import React, { useEffect, useRef } from 'react'

const ComposeMessage = ({ isCompose, setIsCompose, handleCompose }) => {
    const composeRef = useRef();

    useEffect(() => {
        document.addEventListener("mousedown", (e) => {
            if (!composeRef.current.contains(e.target)) {
                setIsCompose(false);
            }
        })
    })

    return (
        <div ref={composeRef} className={`${isCompose ? "-translate-y-1/2" : "translate-y-[400%]"} w-11/12 h-80 sm:h-[25rem] sm:w-[29rem] bg-white fixed top-[55%] sm:top-1/2 left-1/2 -translate-x-1/2 shadow-2xl rounded-lg overflow-hidden transition-all duration-700 ease-linear z-30`
        }>
            <div className='h-12 bg-[#30c381] px-4 flex justify-between items-center'>
                <p className=' text-white text-sm sm:text-base '>
                    <i className="fa-solid fa-envelope mr-1 "></i>
                    Compose Message
                </p>
                <i className="fa-solid fa-xmark text-gray-600 opacity-50 cursor-pointer hover:opacity-100 animation sm:text-lg" onClick={handleCompose}></i>
            </div>

            <div className='flex flex-col items-center gap-4 pt-2 pb-2 sm:pb-16'>
                <div className='flex flex-col items-start px-4 sm:flex-row  gap-2 pr-5 sm:items-center sm:px-0 justify-center h-full w-full '>
                    <label htmlFor="" className='text-gray-700 font-medium sm:font-bold text-sm'>
                        <i className="fa-solid fa-file-lines mr-2 font-bold"></i>
                        Subject:
                    </label>
                    <input type="text" placeholder='subject' className='border-b outline-none w-full h-6 sm:w-9/12 sm:h-10 font-mono text-sm' />
                </div>
                <div className='flex flex-col justify-center px-4 h-full w-full '>
                    <label htmlFor="" className=' text-gray-700 font-medium sm:font-bold text-sm'>
                        <i className="fa-solid fa-message mr-2 mb-2"></i>
                        Message:
                    </label>
                    <textarea name="" className='border h-28 sm:h-32 w-full outline-none pl-4 font-mono text-sm' placeholder='Enter a message'></textarea>
                </div>
            </div>

            <hr />

            <div className='flex justify-between items-center py-2 sm:py-3 px-4 '>
                <div className=''>
                    <button className='text-xs px-3 py-2  text-gray-600 xsm:text-sm xsm:px-4 border-2 rounded-md hover:bg-gray-100 animation'>Cancel</button>
                    <button className='text-xs px-3 py-2 text-white bg-orange-400 xsm:text-sm  xsm:px-4 rounded-md ml-2 hover:bg-orange-500 animation'>Save Draft</button>

                </div>
                <button className='text-xs px-3 py-2 text-white bg-[#30c381] rounded-md xsm:text-sm xsm:px-4 hover:bg-[#25af71] animation'>
                    <i className="fa-solid fa-paper-plane mr-1 "></i>
                    Send
                </button>
            </div>

        </div >

    )
}

export default ComposeMessage;